import React from 'react';
import { Button } from './ui/Button';
import { Check, ShieldCheck, FileText } from 'lucide-react';
export function PurchaseSection() {
  return <section id="compra" className="py-12 px-4 bg-blue-900 text-white relative overflow-hidden" data-id="element-302">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:16px_16px]" data-id="element-303"></div>

      <div className="max-w-md mx-auto relative z-10" data-id="element-304">
        <div className="bg-white text-gray-900 rounded-3xl shadow-2xl overflow-hidden border-4 border-orange-500" data-id="element-305">
          {/* Product Image Section */}
          <div className="bg-gradient-to-b from-gray-50 to-white p-6" data-id="element-306">
            <img src="https://cdn.magicpatterns.com/uploads/9nrHgrHNZX2cKgxXVvQXXf/COVER_TDLO360.png" alt="Teoría de las Organizaciones 360" className="rounded-xl shadow-lg w-full" data-id="element-307" />
          </div>

          {/* Price Section */}
          <div className="px-6 py-8 text-center border-b border-gray-100" data-id="element-308">
            <p className="text-gray-400 text-sm font-semibold uppercase tracking-wider mb-2" data-id="element-309">
              Precio Final
            </p>
            <div className="mb-2" data-id="element-310">
              <span className="text-gray-400 text-2xl line-through" data-id="element-311">
                $49.990
              </span>
            </div>
            <div className="text-blue-900 font-black text-5xl mb-3" data-id="element-312">
              $19.990
            </div>
            <div className="inline-block bg-green-100 text-green-700 px-4 py-1 rounded-full text-sm font-bold" data-id="element-313">
              Ahorrás 60% HOY
            </div>
          </div>

          {/* Features Section */}
          <div className="px-6 py-6 space-y-4" data-id="element-314">
            {/* Feature 1 - Green */}
            <div className="bg-green-50 border border-green-200 rounded-xl p-4 flex gap-3" data-id="element-315">
              <div className="flex-shrink-0 mt-1" data-id="element-316">
                <div className="w-6 h-6 bg-green-500 rounded-full flex items-center justify-center" data-id="element-317">
                  <Check className="w-4 h-4 text-white" strokeWidth={3} data-id="element-318" />
                </div>
              </div>
              <div data-id="element-319">
                <h4 className="font-bold text-gray-900 mb-1" data-id="element-320">
                  Sistema Completo TDLO 360
                </h4>
                <p className="text-sm text-gray-600" data-id="element-321">
                  Clases estructuradas para todo el año lectivo con ejemplos
                  argentinos actuales
                </p>
              </div>
            </div>

            {/* Feature 2 - Beige */}
            <div className="bg-orange-50 border border-orange-200 rounded-xl p-4 flex gap-3" data-id="element-322">
              <div className="flex-shrink-0 mt-1" data-id="element-323">
                <div className="w-6 h-6 bg-orange-500 rounded-full flex items-center justify-center" data-id="element-324">
                  <Check className="w-4 h-4 text-white" strokeWidth={3} data-id="element-325" />
                </div>
              </div>
              <div data-id="element-326">
                <h4 className="font-bold text-gray-900 mb-1" data-id="element-327">
                  2 Bonos Exclusivos (Gratis por hoy)
                </h4>
                <p className="text-sm text-gray-600" data-id="element-328">
                  Banco de actividades rápidas y pack completo de evaluaciones
                  listas
                </p>
              </div>
            </div>

            {/* Feature 3 - Blue */}
            <div className="bg-blue-50 border border-blue-200 rounded-xl p-4 flex gap-3" data-id="element-329">
              <div className="flex-shrink-0 mt-1" data-id="element-330">
                <div className="w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center" data-id="element-331">
                  <Check className="w-4 h-4 text-white" strokeWidth={3} data-id="element-332" />
                </div>
              </div>
              <div data-id="element-333">
                <h4 className="font-bold text-gray-900 mb-1" data-id="element-334">
                  Acceso Inmediato y Vitalicio
                </h4>
                <p className="text-sm text-gray-600" data-id="element-335">
                  Descargá todo el material al instante y accedé cuando lo
                  necesites, sin vencimiento
                </p>
              </div>
            </div>
          </div>

          {/* CTA Button */}
          <div className="px-6 pb-6" data-id="element-336">
            <Button href="https://checkout.rincondigital.shop/cart/52931287646483:1" variant="primary" size="lg" fullWidth withArrow className="shadow-xl shadow-orange-500/30 text-lg py-5" data-id="element-337">
              ACCEDÉ AHORA Y EMPEZÁ A ENSEÑAR
            </Button>
          </div>

          {/* Trust Badges */}
          <div className="px-6 pb-6 flex items-center justify-center gap-6 text-sm text-gray-500" data-id="element-338">
            <div className="flex items-center gap-2" data-id="element-339">
              <ShieldCheck className="h-4 w-4 text-green-500" data-id="element-340" />
              <span data-id="element-341">Compra Segura</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-342">
              <FileText className="h-4 w-4 text-blue-500" data-id="element-343" />
              <span data-id="element-344">Material Digital</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}